import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "ptt_cookie_notice_dismissed";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] bg-[var(--ptt-ink)] text-white border-t border-white/10 animate-in slide-in-from-bottom duration-300"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie size={20} className="text-[var(--ptt-teal)] shrink-0 mt-0.5 sm:mt-0" />
        <p className="text-sm text-white/80 leading-relaxed flex-1">
          We use only strictly necessary cookies/local storage to keep this site working — no third-party advertising or cross-site tracking cookies.{" "}
          <Link to="/privacy#section-14" data-testid="cookie-banner-learn-more" className="text-[var(--ptt-teal)] font-semibold signal-underline" onClick={dismiss}>
            Learn more
          </Link>
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={dismiss}
            data-testid="cookie-banner-accept"
            className="ptt-button px-5 py-2.5 text-sm font-bold"
          >
            Got it
          </button>
          <button
            onClick={dismiss}
            aria-label="Dismiss cookie notice"
            data-testid="cookie-banner-dismiss"
            className="w-9 h-9 grid place-items-center border border-white/15 hover:border-white/40 transition-colors shrink-0"
          >
            <X size={15} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
